const KIOSK_MODULE = "0x2::kiosk";
const KIOSK_TYPE = `${KIOSK_MODULE}::Kiosk`;
const KIOSK_OWNER_CAP = `${KIOSK_MODULE}::KioskOwnerCap`;
const KIOSK_ITEM = `${KIOSK_MODULE}::Item`;
const KIOSK_LISTING = `${KIOSK_MODULE}::Listing`;
const KIOSK_LOCK = `${KIOSK_MODULE}::Lock`;
const KIOSK_PURCHASE_CAP = `${KIOSK_MODULE}::PurchaseCap`;
export {
  KIOSK_ITEM,
  KIOSK_LISTING,
  KIOSK_LOCK,
  KIOSK_MODULE,
  KIOSK_OWNER_CAP,
  KIOSK_PURCHASE_CAP,
  KIOSK_TYPE
};
//# sourceMappingURL=kiosk.js.map
